/**
 * @generated SignedSource<<6a57c50d7bfaffe2cdde92095eba42e1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StreakGamificationStreakRefetchQuery$variables = {
  id: string;
};
export type StreakGamificationStreakRefetchQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"Streak_streak">;
  } | null;
};
export type StreakGamificationStreakRefetchQuery = {
  variables: StreakGamificationStreakRefetchQuery$variables;
  response: StreakGamificationStreakRefetchQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StreakGamificationStreakRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Streak_streak"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StreakGamificationStreakRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "expiresAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "length",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "unlocksAt",
                "storageKey": null
              }
            ],
            "type": "GamificationStreak",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7a6ae0d745d96c4c7bfee0ce910ea17b",
    "id": null,
    "metadata": {},
    "name": "StreakGamificationStreakRefetchQuery",
    "operationKind": "query",
    "text": "query StreakGamificationStreakRefetchQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...Streak_streak\n    id\n  }\n}\n\nfragment Streak_streak on GamificationStreak {\n  expiresAt\n  length\n  unlocksAt\n  id\n}\n"
  }
};
})();

(node as any).hash = "a7033f74b213747c929ef6d533263162";

export default node;
